<div class="deposit-container">
  <div class="deposit-content">
    @if (!showConfirmation) {
      <app-deposit-form
        [formTitle]="formTitle"
        [submitButtonText]="submitButtonText"
        [walletGenerationText]="walletGenerationText"
        [enableWalletGeneration]="enableWalletGeneration"
        [entityId]="entityId"
        [wallets]="filteredWallets"
        [merchant]="merchant"
        [walletResource]="walletResource"
        [isSettlementApp]="isSettlementApp"
        [transactionResource]="transactionResource"
        [walletSelected]="selectedWallet"
        (formSubmitted)="onDepositFormSubmit($event)"
        (blockchainChanged)="onBlockchainChanged($event)"
        (walletCreated)="onWalletCreated($event)"
        (currencyChanged)="onCurrencySelected($event)"
        (walletChanged)="onWalletSelected($event)"
        />
      @if (isSettlementApp) {
        <div class="wallet-selection-panel">
          <div class="panel-header">
            <h3>{{ walletPanelTitle || 'Select Wallet' }}</h3>
            <app-pill-search
              [searchText]="searchText"
              placeholder="Search wallets"
              (searchChange)="onSearchChange($event)"
            ></app-pill-search>
          </div>
          <div class="wallet-grid">
            <!-- Loading indicator -->
            @if (isLoading) {
              <div class="loading-indicator">
                <app-loading-spinner size="large" label="Loading..."></app-loading-spinner>
              </div>
            }
            <!-- Error message -->
            @if (error) {
              <div class="error-message">
                {{ error }}
              </div>
            }
            <!-- No wallets message when filtered results are empty -->
            @if (!isLoading && !error && filteredWallets.length === 0 && searchText) {
              <div class="no-results">
                No wallets found matching "{{ searchText }}".
              </div>
            }
            <!-- No wallets message when there are no wallets at all -->
            @if (!isLoading && !error && wallets.length === 0 && !searchText) {
              <div class="no-results">
                No wallets available for this {{ entityType || 'entity' }}.
              </div>
            }
            @if (!isLoading && !error && filteredWallets.length > 0) {
              <div class="wallets-list">
                <app-virtual-scroll [items]="filteredWallets" size="wallet" [itemHeight]="walletCardHeight">
                  <ng-template let-wallet>
                    <div
                      class="wallet-card-wrapper"
                      role="button"
                      tabindex="0"
                      [attr.aria-pressed]="isWalletSelected(wallet.id)"
                      [ngClass]="{ selected: isWalletSelected(wallet.id) }"
                      (click)="onWalletCardSelected(wallet)"
                      (keydown.enter)="onWalletCardSelected(wallet)"
                      (keydown.space)="$event.preventDefault(); onWalletCardSelected(wallet)"
                      >
                      @if (isWalletNew(wallet.id)) {
                        <div class="new-badge">New</div>
                      }
                      <app-wallet-card
                        [id]="wallet.id"
                        [name]="wallet.walletName || 'Wallet ' + wallet.id.substring(0, 6)"
                        [address]="wallet.address"
                        [networkType]="wallet.networkType"
                        [currencies]="getWalletCurrencies(wallet)"
                        [risk]="getRiskLevelName(wallet.riskLevel)"
                        >
                      </app-wallet-card>
                    </div>
                  </ng-template>
                </app-virtual-scroll>
              </div>
            }
          </div>
        </div>
      }
    } @else {
      @if (confirmationData) {
        <app-deposit-confirmation
          [title]="confirmationTitle"
          [entityName]="confirmationData.entityName"
          [entityLabel]="entityLabel"
          [walletAddress]="confirmationData.walletAddress"
          [amount]="confirmationData.amount"
          [currency]="confirmationData.currency"
          [qrCodeData]="confirmationData.qrCodeData"
          [isSettlementApp]="isSettlementApp"
          [actionButtonText]="actionButtonText"
          [userType]="confirmationData.userType"
          [identifier]="confirmationData.identifier"
          [blockchainLabel]="confirmationData.blockchainLabel"
          (actionButtonClicked)="handleNewDeposit()"
          >
        </app-deposit-confirmation>
      }
      <!-- Show only the selected wallet when in confirmation view -->
      @if (confirmationData && confirmationData.walletId) {
        <div class="selected-wallet-display">
          <h3>Selected Wallet</h3>
          <div class="wallet-grid">
            @if (getSelectedWallet(); as wallet) {
              <div class="wallet-card-wrapper selected">
                <app-wallet-card
                  [id]="wallet.id"
                  [name]="wallet.walletName"
                  [address]="wallet.address"
                  [networkType]="wallet.networkType"
                  [currencies]="getWalletCurrencies(wallet)"
                  [risk]="getRiskLevelName(wallet.riskLevel)"
                  >
                </app-wallet-card>
              </div>
            }
          </div>
        </div>
      }
    }

  </div>
</div>
